'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollContainer = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _lodash = require('lodash');

var _reactRouterDom = require('react-router-dom');

var _styles = require('@material-ui/core/styles');

var _AnimationAccent = require('../AnimationAccent');

var _AnimationAccent2 = _interopRequireDefault(_AnimationAccent);

var _MoreDropDown = require('../MoreDropDown');

var _MoreDropDown2 = _interopRequireDefault(_MoreDropDown);

var _TabList = require('../TabList');

var _TabList2 = _interopRequireDefault(_TabList);

var _constants = require('../constants');

var _ScrollContainer = require('./ScrollContainer.helpers');

var _ScrollContainer2 = require('./ScrollContainer.stylesheet');

var _ScrollContainer3 = _interopRequireDefault(_ScrollContainer2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `ScrollContainer`'s job is to decide how tabs are displayed.
 *
 * - If it's a small screen or mobile device, show the tabs
 *   as a continuous scrollable list.
 *
 * - If it's a larger screen, show the tabs as a constant width.
 *
 * - Also on large screens, show extra tabs in a drop down menu
 *   if there are more than the spec allows.
 */
var ScrollContainer = exports.ScrollContainer = function (_React$PureComponent) {
  (0, _inherits3.default)(ScrollContainer, _React$PureComponent);

  function ScrollContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ScrollContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollContainer.__proto__ || (0, _getPrototypeOf2.default)(ScrollContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      accent: {
        from: {},
        isAnimating: false,
        to: {},
        offset: 0
      },
      displayedTabList: [],
      hasOverflowTabs: false,
      hasScroll: false,
      overflowTabList: []
    }, _this.captureRef = function (comp) {
      if ((0, _lodash.isObjectLike)(comp) && comp.hasOwnProperty('list')) {
        _this.scrollContent = comp.list;
      } else {
        _this.scrollContent = null;
      }
    }, _this.handleAnimationEnd = function () {
      var accent = _this.state.accent;


      _this.setState({
        accent: {
          from: accent.to,
          isAnimating: false,
          offset: 0,
          to: {}
        }
      });
    }, _this.handleNavigate = function (_ref2) {
      var from = _ref2.from,
          to = _ref2.to;

      var nextAccentState = {};

      if (_this.scrollContent) {
        var scrollContent = _this.scrollContent;
        var marginStr = window.getComputedStyle(scrollContent).marginLeft;
        var marginValueStr = /^([\d]{1,3})/.exec(marginStr);
        var marginValueInt = parseInt(marginValueStr, 10);
        nextAccentState.offset = scrollContent.getBoundingClientRect().left - marginValueInt;
      }

      if (to) {
        nextAccentState.to = to;
        nextAccentState.isAnimating = true;
      }

      if (from) {
        nextAccentState.from = from;
      }

      _this.setState({
        accent: (0, _extends3.default)({}, _this.state.accent, nextAccentState)
      });
    }, _this.handleResize = (0, _lodash.debounce)(function () {
      var _this$props = _this.props,
          childrenAsPropsList = _this$props.childrenAsPropsList,
          location = _this$props.location;


      _this.setWidthState(childrenAsPropsList, location.pathname);
    }, 25), _this.setWidthState = function (childrenList, pathname) {
      if (_this.hasScroll) {
        _this.setState({
          displayedTabList: childrenList,
          overflowTabList: [],
          hasScroll: true,
          hasOverflowTabs: false
        });
      } else {
        var _partitionChildren = (0, _ScrollContainer.partitionChildren)(childrenList, pathname),
            _partitionChildren2 = (0, _slicedToArray3.default)(_partitionChildren, 2),
            tabs = _partitionChildren2[0],
            remaining = _partitionChildren2[1];

        _this.setState({
          displayedTabList: tabs,
          overflowTabList: remaining,
          hasScroll: false,
          hasOverflowTabs: !!remaining.length
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ScrollContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          childrenAsPropsList = _props.childrenAsPropsList,
          location = _props.location;


      this.setWidthState(childrenAsPropsList, location.pathname);

      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var childrenAsPropsList = nextProps.childrenAsPropsList,
          location = nextProps.location;
      var displayedTabList = this.state.displayedTabList;

      var isNextTabDisplayed = displayedTabList.find(function (tab) {
        return tab.to === location.pathname;
      });

      if (!isNextTabDisplayed) {
        this.setWidthState(childrenAsPropsList, location.pathname);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = this.props.classes;
      var _state = this.state,
          accent = _state.accent,
          displayedTabList = _state.displayedTabList,
          hasOverflowTabs = _state.hasOverflowTabs,
          hasScroll = _state.hasScroll,
          overflowTabList = _state.overflowTabList;


      var containerClassList = (0, _classnames3.default)(classes.container, (0, _defineProperty3.default)({}, classes.container__isScrollable, hasScroll));

      return React.createElement(
        'div',
        { className: containerClassList },
        React.createElement(
          _TabList2.default,
          {
            childMap: displayedTabList,
            onNavigate: this.handleNavigate,
            showAccent: !accent.isAnimating,
            innerRef: this.captureRef
          },
          hasOverflowTabs && React.createElement(_MoreDropDown2.default, { childMap: overflowTabList })
        ),
        React.createElement(_AnimationAccent2.default, (0, _extends3.default)({
          onAnimationEnd: this.handleAnimationEnd
        }, accent))
      );
    }

    // : { from?: AccentMetaType, to?: AccentMetaType}

  }, {
    key: 'hasScroll',
    get: function get() {
      var isIE = !!window.MSInputMethodContext && !!document.documentMode;
      var query = 'screen and (max-width: ' + (_constants.BREAKPOINTS_MAP.MD - 0.1) + 'px)';
      var isSmallerScreen = window.matchMedia(query).matches;

      return !isIE && isSmallerScreen;
    }
  }]);
  return ScrollContainer;
}(React.PureComponent);

ScrollContainer.defaultProps = {
  classes: {},
  location: {
    pathname: ''
  }
};
exports.default = (0, _styles.withStyles)(_ScrollContainer3.default)((0, _reactRouterDom.withRouter)(ScrollContainer));